export default "__VITE_ASSET__472c5127__"